/**
 * Сервис для работы с KPI сотрудников
 */

import api from './api';
import { KPI, KPICreate, KPIUpdate, KPIFilter, KPIResponse } from '../types/kpi';

class KPIService {
  /**
   * Создает запись KPI сотрудника
   */
  async createEmployeeKPI(data: KPICreate): Promise<{ kpi_id: string; status: string }> {
    return await api.post('/kpi/employee', data);
  }

  /**
   * Получает KPI сотрудника по ID
   */
  async getEmployeeKPI(id: string): Promise<KPI> {
    return await api.get(`/kpi/employee/${id}`);
  }

  /**
   * Получает список KPI сотрудников
   */
  async getEmployeeKPIs(filters: KPIFilter = {}): Promise<KPIResponse> {
    const params = new URLSearchParams();
    if (filters.date_from) params.append('date_from', filters.date_from);
    if (filters.date_to) params.append('date_to', filters.date_to);
    if (filters.employee_id) params.append('employee_id', filters.employee_id);
    if (filters.restaurant_id) params.append('restaurant_id', filters.restaurant_id);
    if (filters.kpi_min) params.append('kpi_min', filters.kpi_min.toString());
    if (filters.kpi_max) params.append('kpi_max', filters.kpi_max.toString());
    if (filters.search) params.append('search', filters.search);
    if (filters.sort_by) params.append('sort_by', filters.sort_by);
    if (filters.sort_order) params.append('sort_order', filters.sort_order);
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    
    return await api.get(`/kpi/employee?${params.toString()}`);
  }

  /**
   * Обновляет KPI сотрудника
   */
  async updateEmployeeKPI(id: string, data: KPIUpdate): Promise<{ kpi_id: string; status: string }> {
    return await api.put(`/kpi/employee/${id}`, data);
  }

  /**
   * Удаляет (очищает) KPI сотрудника
   */
  async deleteEmployeeKPI(id: string): Promise<{ kpi_id: string; status: string }> {
    return await api.delete(`/kpi/employee/${id}`);
  }


  /**
   * Синхронизирует KPI с Google Sheets
   */
  async syncKPIWithSheets(id: string): Promise<{ kpi_id: string; status: string }> {
    return await api.post(`/kpi/employee/${id}/sync`);
  }

  /**
   * Массовая синхронизация KPI с Google Sheets
   */
  async bulkSyncKPIWithSheets(ids: string[]): Promise<{
    synced_count: number;
    failed_count: number;
    failed_ids: string[];
  }> {
    return await api.post('/kpi/employee/bulk-sync', { kpi_ids: ids });
  }
}

export default new KPIService();